import React, { useContext } from 'react';
import { Button, Col, Drawer, Form, Row } from 'antd';
import PropTypes from 'prop-types';
import useMobileBreakpoint from '../../../../../../../hooks/useMobileBreakpoint';
import { EnrollmentFormContext } from '../../../../../../../providers/EnrollmentFormContextProvider';
import MandataryForm from '../Form/MandataryPerson/MandataryForm';
// import DocumentTypeKey from '../../../../../../../enums/DocumentTypeKey';
// import file from '../../../../../../../utils/file';
import tokens from '../../../../../../../utils/tokens';
// import useEnrollmentUpdate from '../../../../../../../hooks/useEnrollmentUpdate';
import form from '../../../../../../../utils/form';

const AuthorizedPersonDrawerForm = ({ visible, closeDrawer, field, title, index, forceRender }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  // const [updateEnrollment, isLoading] = useEnrollmentUpdate();

  const isMobile = useMobileBreakpoint();

  const handleSubmit = async () => {
    // const formValues = enrollmentForm.getFieldsValue(true);
    // const mandataryPeople = await Promise.all(
    //   formValues.mandataryPeople.map(async (mandataryPerson) => {
    //     const documents = [];

    //     await Promise.all(
    //       (mandataryPerson.documents || []).map(async (uploadedFile) => {
    //         const { name, originFileObj } = uploadedFile;
    //         const base64 = await file.toBase64(originFileObj);

    //         documents.push({
    //           filename: name,
    //           base64,
    //           typeKey: DocumentTypeKey.MANDATARY_PERSON_POWER,
    //         });
    //       })
    //     );

    //     return {
    //       ...mandataryPerson,
    //       documents,
    //     };
    //   })
    // );

    // const updatePayload = {
    //   mandataryPeople,
    // };

    // updateEnrollment(updatePayload);
    closeDrawer();
    // sw lleno un drawer
  };

  return (
    <Drawer
      title="Documentos Personales"
      width={isMobile ? null : 720}
      onClose={() => {
        closeDrawer();
      }}
      visible={visible}
      bodyStyle={{ paddingBottom: 80 }}
      forceRender={forceRender}
    >
      <p className="personalDocumentsForm__title">{title}</p>
      <Form
        layout="vertical"
        form={enrollmentForm}
        onFinish={handleSubmit}
        validateMessages={form.validateMessages}
      >
        <Form.List name="mandataryPeople">
          {() => (
            <>
              <MandataryForm field={field} index={index} />
              <Row gutter={[tokens.forms.horizontalGutterInPx]}>
                <Col span={12}>
                  <Form.Item>
                    <Button type="primary" block htmlType="button" onClick={handleSubmit}>
                      Confirmar
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </Form.List>
      </Form>
    </Drawer>
  );
};

AuthorizedPersonDrawerForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  closeDrawer: PropTypes.func.isRequired,
  field: PropTypes.shape().isRequired,
  index: PropTypes.number.isRequired,
  forceRender: PropTypes.bool,
};

AuthorizedPersonDrawerForm.defaultProps = {
  forceRender: false,
};

export default AuthorizedPersonDrawerForm;
